var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 640,
    viewBox: "0 0 640 640",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M325.119 311.933C315.044 318.815 309.743 329.827 308.753 341.775C307.448 325.841 302.35 315.612 286.341 311.964C302.732 310.691 306.933 297.455 310.341 283.459C309.701 295.378 312.159 308.181 324.748 312.413",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.083 198.054C215.033 199.689 215.896 201.433 216.961 202.996",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.347 219.255C235.918 235.917 246.874 252.211 255.396 269.424",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M253.172 161.203C262.711 187.001 269.682 213.991 280.01 239.458",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M310.873 151.855C311.244 168.229 311.587 184.603 311.942 200.97",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M312.106 221.021C312.295 223.967 312.334 226.916 312.504 229.862",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M364.186 205.074C352.009 223.511 339.879 241.924 328.111 260.639M386.173 170.786C380.948 183.583 371.701 193.703 364.189 205.078",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M375.177 254.727C384.588 247.158 393.48 237.98 401.824 229.245",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M413.685 218.614C417.192 215.145 420.97 211.974 424.483 208.507",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M461.868 261.355C434.332 275.901 403.24 288.852 373.497 298.668",
    stroke: "black",
    strokeWidth: 14.7441,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M247.076 295.618C220.148 279.698 192.457 265.596 164.886 250.898",
    stroke: "black",
    strokeWidth: 14.7441,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M241.247 319.721C235.779 319.91 230.328 320.13 224.888 320.706",
    stroke: "black",
    strokeWidth: 14.7441,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M205.158 321.838C190.602 322.613 175.832 322.467 161.347 324.075",
    stroke: "black",
    strokeWidth: 14.7441,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M374.851 328.199C381.393 328.416 388.828 328.842 395.33 330.169",
    stroke: "black",
    strokeWidth: 14.7441,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M416.443 335.021C437.609 337.244 458.213 343.025 479.086 346.64",
    stroke: "black",
    strokeWidth: 14.7441,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M266.427 339.338C234.258 363.744 199.766 384.506 167.689 409.109",
    stroke: "black",
    strokeWidth: 14.7441,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M274.094 370.783C259.192 391.061 249.489 414.873 237.312 436.74",
    stroke: "black",
    strokeWidth: 14.7441,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M266.582 488.138C269.264 473.583 274.664 459.265 278.797 445.088C281.483 435.871 283.017 425.892 287.325 417.236",
    stroke: "black",
    strokeWidth: 14.7441,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M295.078 400.3C296.242 397.389 296.982 394.309 298.248 391.442",
    stroke: "black",
    strokeWidth: 14.7441,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M321.189 378.402C329.646 407.911 335.536 438.228 343.239 467.979",
    stroke: "black",
    strokeWidth: 14.7441,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M354.339 360.841C367.895 375.793 384.78 387.957 397.794 403.255",
    stroke: "black",
    strokeWidth: 14.7441,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M417.036 419.764C420.442 423.717 424.402 427.46 428.203 431.029",
    stroke: "black",
    strokeWidth: 14.7441,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.303afda283b3b1f730e93baa12f454c1.svg";
export { ForwardRef as ReactComponent };